import React,{useState} from 'react'
import './header.css'
import {Link} from 'react-router-dom'
import { MdClose } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
export default function Header() {
  const [data,setData]=useState(false)

  const menu=()=>{
    setData(!data)
  }
  const close =()=>{
    if (data===true)
      setData(!data)
  }
  return (
    <div className='header'>
      <div className='c1'>
        <div className='side'>
          {/*solar heading*/}
          <div>
            <img className='logo' src='./logo.jpeg' alt=''/>
          </div>
          {/*hamburg menu*/}
        <div className='ham'>
          <GiHamburgerMenu onClick={menu} className='icon1'/>
        </div>
        </div>
        
        {/*all heading*/}
        <ul className={data ?'mob':'lap'}>
        
          <li> 
            <div className='close'>
              <MdClose onClick={menu} className='icon2'/>
            </div>
          </li>
          <li><Link to='/' onClick={close}  className='linking'>Home</Link></li>
          <li><Link to='/about' onClick={close}   className='linking'>About</Link></li>
          <li><Link to='/services' onClick={close}  className='linking'>Services</Link></li>
          <li><Link to='/appoint' onClick={close} className='linking'><button>Book Appointment</button></Link></li>
          <li><Link to='/products' onClick={close} className='linking'>Products</Link></li>
        </ul>
      </div>
    </div>
  )
}
